// src/pages/DashboardPage.jsx
import Layoutpp from "../layouts/Layoutpp";
import PlacementOfficer from "./PlacementOfficer";

const Jobreq = () => {

  return (
    <Layoutpp title="Create Job Requirement">
        {/* Main Content */}
        <div style={{ flex: 1 }}>
          <PlacementOfficer/>
        </div>
    </Layoutpp>
  );
};

export default Jobreq;
